//////Local Storage Data///////

import * as XLSX from "xlsx";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import Axios from "axios";
import "./AdminPage.css";
import Modal from "react-bootstrap/Modal";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Overlay } from "react-bootstrap";
import { Popover } from "react-bootstrap";
import { format } from "date-fns";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Button } from "react-bootstrap";
import Alert from 'react-bootstrap/Alert';

const AdminPage = (props) => {
  const getLocalItems = () => {
    let monthsdata = localStorage.getItem("items");
    if (monthsdata) {
      return JSON.parse(localStorage.getItem("items"));
    } else {
      return [];
    }
  };

  // react-table library essential to create an instance of the table
  const [date, setDate] = useState(new Date());
  const { instance } = useMsal();
  const [items, setItems] = useState(getLocalItems());
  const [inputChange, setInputChange] = useState("");
  const [show, setShow] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [target, setTarget] = useState(null);
  const [isupload, setUpload] = useState(false);
  const [isSuccess, setSuccess] = useState(false);


  let nowDate = new Date();

  let myTimeout;
  let selectedMonth = "";
  let selectedYear = "";
  const usersList = [
    "uma.rani.battu@ds.dev.accenture.com",
    "uma.rani.battu@accenture.com",
    "jeevadharani.ramanan@accenture.com",
    "reshmi.haridas.m@accenture.com",
    "kusume.sridhar@accenture.com",
    "sumathi.a.anand@accenture.com",
    "ankur.e.mishra@accenture.com",
    "ankur.e.mishra@ds.dev.accenture.com",
    "aluru.akash@accenture.com",
    "arpita.m.singh@accenture.com",
    "h.srinivasan@accenture.com",
    "m.snehalatha@accenture.com",
    "j.b.bhardwaj@accenture.com",
    "aayushi.bharti@accenture.com",
    "aayushi.bharti@ds.dev.accenture.com",
    "rajath.mb@accenture.com",
    "shramika.s.ambolkar@accenture.com",
    "shramika.s.ambolkar@ds.dev.accenture.com",
    "varsha.a.tyagi@accenture.com",
    "d.d.choudhary@accenture.com",
    "potnuru.sandeep@accenture.com",
    "potnuru.sandeep@ds.dev.accenture.com"
  ];
  const activeAccount = instance.getActiveAccount();
  let activeUsername = '';
    if(activeAccount)
        activeUsername = activeAccount.username;
  
  // console.log(activeUsername,"activeUsernameee value");
  const [modalShow, setModalShow] = React.useState(false);
  function alertClose() {
    setUpload(false)
    setSuccess(false)
  }
  useEffect(() => {    
    if (activeAccount) {      
      const val = usersList.some((item) => item === activeAccount.username)
        ? setShowUser(true)
        : "Byee";

      console.log(val);
    } else {
      console.log("Something Wrong...!");
    }
  }, [activeAccount]);
  console.log(show);
  const ref = useRef();

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const workbook = XLSX.read(bufferArray, [{ type: "buffer" }]);
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const toJsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        resolve(toJsonData);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
    promise.then((data) => {
      setItems(data);
    });
  };

  const chageEvent = (e) => {
    const file = e.target.files[0];
    setInputChange(file);
  };
  const submitFile = (e) => {
    const data = new FormData();
    data.append("file", inputChange);
    const info = {
      data,
      month,
      year,
    };
    setUpload(false)

    console.log("info is", data);
    readExcel(inputChange);
    ref.current.value = "";
    Axios.post(
      `https://atci.lkm.accenture.com/LKM-Calendar-Apis/upload/${activeUsername}`,
      // 'http://localhost:3002/upload/${activeUsername}',
      data,
      {
        headers: {              
          'Authorization': localStorage.getItem("token"),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        // then print response status
        console.log(res.statusText, 'response status');
        setUpload(true)
        setSuccess(true)
        props.setPageUpdate(true);
        myTimeout = setTimeout(alertClose, 7000);

        // setMonth("")
        // setYear("")
      })
      .catch((err) => {
        // then print response status
        console.error("upload fail");
        setSuccess(false)
        setUpload(true)
        myTimeout = setTimeout(alertClose, 7000);
      });
  };

  const selectFunction = (value) => {
    setDate(value);
    selectedMonth = format(value, "MMM");

    setMonth(selectedMonth.toLocaleLowerCase());

    selectedYear = format(value, "yyyy");
    setYear(selectedYear);
    setShow(!show);
    console.log("selee", selectedMonth.toLocaleLowerCase());
  };
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const formHandler = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    localStorage.setItem("items", JSON.stringify(items));
  }, [items]);
  const downloadExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(items);
    XLSX.utils.decode_cell({});
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.utils.decode_cell(ws);
    XLSX.writeFile(wb, "Trainings_Data.xlsx");
  };

  return (
    <div>
      {showUser && (
        <div className="admin_container">
          {isupload && (<Alert variant={isSuccess ? "success" : "danger"} onClose={() => setUpload(false)} dismissible style={{ width: "400px", height: "50px", marginTop: "13px", marginRight: "20px", display: "flex", justifyContent: "center", alignItems: "center", zIndex: "1000000" }}>
            <Alert.Heading style={{ fontSize: "16px", alignSelf: "center", paddingTop: "10px", paddingLeft: "25px" }}>
              {isSuccess ? " Uploaded Successfully!!!" : "Upload failed! Please check the date format, it should be \"YYYY-MM-DD\"."}
            </Alert.Heading>
          </Alert>)}
          {console.log(isSuccess, 'success ki value')}
          <Button
            className="uploadButton"
            onClick={() => {
              setModalShow(true);
              setShow(false);
              props.setCalendar(false);
              setUpload(false)
            }}
          >
            Admin
          </Button>

          <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <div className="Model-Content-Text">
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  File Upload
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* <label classname="lkm-calendar-upload-text">Select Month and Year :</label>
                <span className="calender-container">
                  <div className="admin_calender_button" onClick={handleClick}>
                    Click here to Select
                    <FaRegCalendarAlt className="admin_calendar-icon" />
                  </div>
                  <label className="date-display">
                    {month.toUpperCase()} {year}
                  </label>
                </span> */}
                <Overlay
                  show={show}
                  target={target}
                  placement="right"
                  containerPadding={0}
                >
                  <Popover id="popover-contained">
                    <Popover.Body>
                      <div className="calender">
                        <div className="calendar-container">
                          <Calendar
                            onChange={selectFunction}
                            value={date}
                            maxDetail="year"
                            minDate={new Date(2021, 12, 1)}
                            maxDate={new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 1)}
                          />
                        </div>
                      </div>
                    </Popover.Body>
                  </Popover>
                </Overlay>

                <form onSubmit={formHandler} id="form">
                  {
                    <div>
                      <label>Select File to Upload :</label>
                      <div className="upload-form">
                        <input
                          type="file"
                          className="mainData"
                          accept=".xlsx"
                          ref={ref}
                          id="file"
                          onChange={chageEvent}
                        />
                        <label htmlFor="file" className="file_lable">
                          &uArr; Upload File
                        </label>
                        <span className="file_caption">
                          {inputChange.name
                            ? inputChange.name
                            : "No File Selected"}
                        </span>
                      </div>
                    </div>
                  }
                </form>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="submit-btn"
                  type="button"
                  disabled={inputChange !== "" ? false : true}
                  onClick={() => {
                    setModalShow();
                    submitFile();
                  }}
                >
                  Publish Calendar
                </Button>
                <div>
                  <span className="lkm-calendar-upload-instructions">Instructions</span>
                  <div>
                    <ol className="Instructions-List">
                      <li>
                        To publish the calendar by uploading the template, in case if there is any doubt or clarification please refer the <a href="images/LKMCALENDAR-Job-Aid.docx" className="lkm-calendar-sample-file">job aid</a>.
                      </li>
                      <li>
                        The calendar needs to be uploaded in a given template format. Any change in the template will lead
                        to upload failure or error messages.
                        <a href={require("../../data/CalendarData.xlsx")} download="CalendarData.xlsx" target="_blank" className="lkm-calendar-sample-file"
                          rel="noreferrer"> Click here </a>
                        to download the calendar template.
                      </li>
                      <li> Also please make sure the column data "SessionStartDate" and "SessionEndDate" must be in "YYYY-MM-DD" format. For eg. 2023-08-14</li>
                      {/* <li>Please make sure the excel file to be uploaded must be named as "CalendarData.xlsx". Any change in the file name will lead to upload failure.</li> */}
                      <li>
                        For a successful upload of new calendar data every time use new excel file, avoid making changes to the older one.
                      </li>
                      <li>
                        Please avoid uploading or updating the calendar frequently to avoid any issues. In case if any corrections
                        required and its unavoidable please re-upload the calendar again and publish the calendar.
                      </li>
                      {/* <li>
                              Please do not exceed maximum three times of uploading or correcting the calendar for the respective 
                              month as per the governance and terms.
                          </li>*/}
                      <li>
                        Uploaded calendar can be modified to the max of 5 times.
                      </li>
                      <li>
                        In case if you need to add or remove access for admin page please contact <a href="mailto:ATCI.L-TT.LX.PORTALDEVELOPMENT@accenture.com" className="lkm-calendar-sample-file">ATCI.L-TT.LX.PORTALDEVELOPMENT@accenture.com</a>
                      </li>
                      <li>
                        Whenever there is a change in the calendar page, admins will be notified via mail
                      </li>
                      <li>
                        The members who have admin access :
                        <table className="table_Names">
                          <tr>
                            <td>h.srinivasan</td>
                            <td>varsha.a.tyagi</td>
                            <td>jeevadharani.ramanan</td>
                            <td>uma.rani.battu</td>
                            <td>reshmi.haridas.m</td>
                          </tr>
                          <tr>
                            <td>sumathi.a.anand</td>
                            <td>arpita.m.singh</td>
                            <td>kusume.sridhar</td>
                            <td>m.snehalatha</td>
                            <td>aluru.akash</td>
                          </tr>
                          <tr>
                            <td>aayushi.bharti</td>
                            <td>rajath.mb</td>
                            <td>j.b.bhardwaj</td>
                            <td>shramika.s.ambolkar</td>
                            <td>ankur.e.mishra</td>
                          </tr>
                        </table>
                      </li>
                    </ol>
                  </div>
                </div>
              </Modal.Footer>
            </div>
          </Modal>
        </div>
      )}
    </div>
  );
};
export default AdminPage;
